var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"ifram",attrs:{"src":("/api/static/html/" + _vm.page),"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }